import React from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
} from 'react-router-dom';
import { useStore } from 'store/store';

const PrivateRoute = ({ component, ...rest }: RouteProps) => {
  const userData = useStore((state) => state.userData);
  if (!component) {
    return (
      <React.Fragment>
        Component is not passed! Please pass the valid react component.
      </React.Fragment>
    );
  }

  const Component: React.ComponentType<any> = component;
  const render = (props: RouteComponentProps<any>) => {
    return userData ? (
      <Component {...props} />
    ) : (
      <Redirect to={{ pathname: '/verify', state: { from: props.location } }} />
    );
  };

  return <Route {...rest} render={render} />;
};

export default PrivateRoute;
